import QuestionTypeIcon from "@/components/QuestionIcon";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { QUESTION_TYPE_INFO } from "@/schemas/question";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import MoveDownButton from "./components/MoveDownButton";
import MoveUpButton from "./components/MoveUpButton";
import RemoveButton from "./components/RemoveButton";

interface QuestionCardProps {
  children: React.ReactNode;
  index: number;
  type: string;
  isFirst: boolean;
  isLast: boolean;
  disabled?: boolean;
  className?: string;
}

const getCardTitle = (type: string) => {
  switch (type) {
    case QUESTION_TYPE_INFO:
      return "info";
    default:
      return "default";
  }
};

export default memo(function QuestionCard({
  children,
  index,
  type,
  isFirst,
  isLast,
  className,
}: QuestionCardProps) {
  const { t } = useTranslation();
  const questionNumber = index + 1;
  const isOdd = index % 2 === 1;

  return (
    <Card
      className={cn(
        "grid [grid-template-areas:'order_header''order_content'] grid-cols-[auto_1fr]",
        isOdd ? "bg-slate-50" : "",
      )}
    >
      <section className="[grid-area:order] shrink-0 flex flex-col py-2 px-2">
        <MoveUpButton index={index} isFirst={isFirst} />
        <MoveDownButton index={index} isLast={isLast} />
      </section>
      <CardHeader className="[grid-area:header] flex flex-row items-center space-y-0 py-2 pl-0 pr-3">
        <CardTitle className="grow text-md px-1 font-bold flex flex-row items-center gap-2">
          <QuestionTypeIcon type={type} />
          {t(`surveyEditor.questionTitle.${getCardTitle(type)}`)}{" "}
          {questionNumber}
        </CardTitle>
        <RemoveButton index={index} />
      </CardHeader>
      <CardContent
        className={cn(className, "[grid-area:content] pl-1 pt-1 pb-8")}
      >
        {children}
      </CardContent>
    </Card>
  );
});
